import { FC, ReactNode, useRef } from 'react'
import { useInView, useScroll, useTransform } from 'framer-motion'

import { Align, Circle, CircleWrapper, Container } from './styled'

type Props = {
  align: Align
  children: ReactNode
}

export const Circles: FC<Props> = ({ align, children }) => {
  const ref = useRef<HTMLDivElement>(null)
  useInView(ref)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', `end start`],
  })
  const y = useTransform(scrollYProgress, [0, 1], [400, -400])

  return (
    <Container>
      <CircleWrapper ref={ref} $align={align}>
        <Circle $align={align} style={{ y }} />
      </CircleWrapper>
      {children}
    </Container>
  )
}
